var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_ProfitShareAdjust"),
        width: "1020px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        "custom-class": "details-view profit-share-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                model: _vm.shareAmount,
                "label-width": "100px",
                "label-position": "right"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "el-form-item-wrapper",
                  staticStyle: { "padding-top": "5px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_UsdProfit") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "usdProfitSum",
                          disabled: true,
                          precision: 2,
                          controls: false
                        },
                        model: {
                          value: _vm.shareAmount.usdProfitSum,
                          callback: function($$v) {
                            _vm.$set(_vm.shareAmount, "usdProfitSum", $$v)
                          },
                          expression: "shareAmount.usdProfitSum"
                        }
                      }),
                      _vm._v(" USD ")
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_NonUsdProfit") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "nonUsdProfitSum",
                          disabled: true,
                          precision: 2,
                          controls: false
                        },
                        model: {
                          value: _vm.shareAmount.nonUsdProfitSum,
                          callback: function($$v) {
                            _vm.$set(_vm.shareAmount, "nonUsdProfitSum", $$v)
                          },
                          expression: "shareAmount.nonUsdProfitSum"
                        }
                      }),
                      _vm._v(" " + _vm._s(_vm.localCurrency) + " ")
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_JobProfit") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "jobProfitSum",
                          disabled: true,
                          precision: 2,
                          controls: false
                        },
                        model: {
                          value: _vm.shareAmount.jobProfitSum,
                          callback: function($$v) {
                            _vm.$set(_vm.shareAmount, "jobProfitSum", $$v)
                          },
                          expression: "shareAmount.jobProfitSum"
                        }
                      }),
                      _vm._v(" " + _vm._s(_vm.localCurrency) + " ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "el-form-item-wrapper",
                  staticStyle: { "padding-top": "5px", "padding-bottom": "5px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_ShareMode") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "130px" },
                          attrs: { no: "shareMode", disabled: true },
                          on: {
                            change: function($event) {
                              return _vm.changeShareAmount()
                            }
                          },
                          model: {
                            value: _vm.shareAmount.shareMode,
                            callback: function($$v) {
                              _vm.$set(_vm.shareAmount, "shareMode", $$v)
                            },
                            expression: "shareAmount.shareMode"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_ShareModeJob"),
                              value: "job"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_ShareModeCurrency"),
                              value: "currency"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.shareAmounts,
                      "auto-fit-content": false,
                      "min-height": "140px"
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "el-form-item-wrapper",
                  staticStyle: {
                    "padding-top": "10px",
                    "padding-bottom": "5px",
                    "border-top": "1px solid #000000"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("CargoMsg.Cargo_UsdProfit") +
                          _vm.$t("CargoMsg.Cargo_AdjustColumn")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "usdProfitAdjust",
                          disabled: true,
                          precision: 2,
                          controls: false
                        },
                        model: {
                          value: _vm.shareAmount.usdProfitAdjust,
                          callback: function($$v) {
                            _vm.$set(_vm.shareAmount, "usdProfitAdjust", $$v)
                          },
                          expression: "shareAmount.usdProfitAdjust"
                        }
                      }),
                      _vm._v(" USD ")
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("CargoMsg.Cargo_NonUsdProfit") +
                          _vm.$t("CargoMsg.Cargo_AdjustColumn")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "nonUsdProfitAdjust",
                          disabled: true,
                          precision: 2,
                          controls: false
                        },
                        model: {
                          value: _vm.shareAmount.nonUsdProfitAdjust,
                          callback: function($$v) {
                            _vm.$set(_vm.shareAmount, "nonUsdProfitAdjust", $$v)
                          },
                          expression: "shareAmount.nonUsdProfitAdjust"
                        }
                      }),
                      _vm._v(" " + _vm._s(_vm.localCurrency) + " ")
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("CargoMsg.Cargo_JobProfit") +
                          _vm.$t("CargoMsg.Cargo_AdjustColumn")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "jobProfitAdjust",
                          disabled: true,
                          precision: 2,
                          controls: false
                        },
                        model: {
                          value: _vm.shareAmount.jobProfitAdjust,
                          callback: function($$v) {
                            _vm.$set(_vm.shareAmount, "jobProfitAdjust", $$v)
                          },
                          expression: "shareAmount.jobProfitAdjust"
                        }
                      }),
                      _vm._v(" " + _vm._s(_vm.localCurrency) + " ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefsAdjust,
                      "row-data": _vm.shareBranchList,
                      "auto-fit-content": false,
                      "min-height": "140px"
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApiJob = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { float: "right" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "confirm" },
              on: { click: _vm.onConfirm }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "cancel" }, on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }